export const INCOMING_SYRVE_DOCUMENT_TYPES = ['IncomingInvoice', 'ServiceReceipt'] as const;
export const OUTGOING_SYRVE_DOCUMENT_TYPES = ['OutgoingInvoice', 'ServiceProvision'] as const;

export type SyrveDocumentTypeFilter = 'all' | 'incoming' | 'outgoing';

export function parseSyrveDocumentTypeFilter(value: string | null): SyrveDocumentTypeFilter {
  if (value === 'incoming' || value === 'outgoing') {
    return value;
  }
  return 'all';
}

export function isIncomingSyrveDocumentType(documentType: string) {
  return INCOMING_SYRVE_DOCUMENT_TYPES.some(
    (type) => type.localeCompare(documentType, undefined, { sensitivity: 'accent' }) === 0,
  );
}

export function isOutgoingSyrveDocumentType(documentType: string) {
  return OUTGOING_SYRVE_DOCUMENT_TYPES.some(
    (type) => type.localeCompare(documentType, undefined, { sensitivity: 'accent' }) === 0,
  );
}

export function matchesSyrveDocumentTypeFilter(documentType: string, filter: SyrveDocumentTypeFilter) {
  if (filter === 'all') {
    return true;
  }
  if (filter === 'incoming') {
    return isIncomingSyrveDocumentType(documentType);
  }
  return isOutgoingSyrveDocumentType(documentType);
}
